export default __webpack_public_path__ + "static/media/Melania Mazzucco.77f71c53.jpg";